module.exports = __webpack_public_path__ + "music-studio@450x300.9b41d25e.jpg";